import initialState from "../misc/initial-state";
import router from "../misc/router";
import { track } from "../misc/utils";

export const setImage = (kind, data) => state => {
  state.images[kind] = data;
  return state;
};

export const setArea = area => state => {
  router.next({ area });
  if (area === "Landing") {
    state = initialState.all();
  }
  state.area = area;
  return state;
};

export const setProductId = productId => state => {
  state.productId = productId;
  return state;
};

export const setAreaFromHash = state => {
  const hash = window.location.hash.replace("#", "").split("area=");
  if (hash.length !== 2) {
    return;
  }
  return setArea(hash[1])(state);
};

export const setError = error => state => {
  state.error = error;
  return state;
};

export const handleBack = state => {
  const area = router.last(state).area;
  router.next({ area });
  state.area = area;
  if (area === "Landing") {
    track.event("button", "click", "Arrow1-Back_To_Landing");
    state = initialState.all({area: area});
  }
  if (area === "SelectBackground") {
    track.event("button", "click", "Arrow2-Back_To_Backgroung");
  }
  if (area === "EditorSimple") {
    track.event("button", "click", "Arrow3-Back_To_Editor");
  }
  if (area === "CropPhoto") {
    track.event("button", "click", "Arrow4-Back_To_Crop");
  }
  return state;
};

export const setLoading = loading => state => {
  state.loading = loading;
  return state;
};

// TODO:
export const setLabel = ({ labelId, labelUrl }) => state => {
  state.labelId = labelId;
  state.labelUrl = labelUrl;
  return state;
};

export const setFiltered = filtered => state => {
  state.filtered = filtered;
  return state;
};

export const addText = text => state => {
  state.label.text.push(text);
  return state;
};



// WEBPACK FOOTER //
// ./src/actions/app.js